import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    MDBContainer,
    MDBNavbar,
    MDBIcon,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBDropdownLink
} from 'mdb-react-ui-kit';
import { useLanguage } from '../../context/language';
import { getURLBtnBackToPanel } from '../../context/brokersUrl';

export default function Navbar() {
    const history = useHistory();
    const location = useLocation();
    const { translate, lang, optionsLang } = useLanguage();
    const [param, setParam] = useState(null);

    //Ao ser executado o componente verifica o parametro e atualiza o destino do link do botão
    useEffect(() => {       
        setParam(getURLBtnBackToPanel());
    }, [translate, param]);

    //Tradução
    useEffect(() => {  
        translate();
    }, [translate]);

    //Função utilizada na parte de selecionar o idioma
    function langOption(opt) {        
        let indexSelected = optionsLang.findIndex(x => x.nameLang === lang.nameLang);
        let arrObjLang = [];

        if (opt === "selected") {
            return lang;
        } else {
            for (let index = 0; index < optionsLang.length; index++) {
                if (index !== indexSelected) {
                    arrObjLang.push(optionsLang[index]);
                }
            }
            return arrObjLang[opt];
        }
    }

    //definindo o idioma com base na origem da ordem
       

    return (
        <MDBNavbar light bgColor='light'>
            <MDBContainer fluid>
                <MDBNavbarNav className='d-md-flex justify-content-md-between main-nav-content'>
                    <MDBNavbarItem>
                        <MDBDropdown>
                            <MDBDropdownToggle tag='a' className='nav-link'>
                                <MDBIcon flag={langOption("selected").nameFlag} />
                            </MDBDropdownToggle>
                            <MDBDropdownMenu>
                                <MDBDropdownItem>
                                    <MDBDropdownLink onClick={() => { translate(langOption(0).nameLang) }}>
                                        <MDBIcon flag={langOption(0).nameFlag} />
                                    </MDBDropdownLink>
                                </MDBDropdownItem>
                                <MDBDropdownItem>
                                    <MDBDropdownLink onClick={() => { translate(langOption(1).nameLang) }}>
                                        <MDBIcon flag={langOption(1).nameFlag} />
                                    </MDBDropdownLink>
                                </MDBDropdownItem>
                            </MDBDropdownMenu>
                        </MDBDropdown>
                    </MDBNavbarItem>
                    <MDBNavbarItem>
                        {param !== "#" &&
                            <a className='btn btn-primary btn-sm' data-lang-str="btn_Panel" href={param !== null ? param : "#"} target="_blank" rel="noreferrer"></a>
                        }
                    </MDBNavbarItem>
                </MDBNavbarNav>
            </MDBContainer>
        </MDBNavbar>
    );
}